import Vue from 'vue';
import smoothscroll from 'smoothscroll-polyfill';
import PortalVue from 'portal-vue'
import VueProgressBar from 'vue-progressbar'
import VTooltip from 'v-tooltip'
import _ from 'lodash'
import Ads from 'vue-google-adsense'


window._ = _

window.Vue = Vue;
smoothscroll.polyfill();

Vue.use(PortalVue)

Vue.mixin(require('./trans'))

Vue.use(VueProgressBar, {
    color: '#09c134bf',
    failedColor: '#b00020',
    thickness: '2px'
})

Vue.use(require('vue-script2'))
Vue.use(Ads.Adsense)
Vue.use(Ads.InArticleAdsense)
Vue.use(Ads.InFeedAdsense)

Vue.use(VTooltip)

document.addEventListener("DOMContentLoaded", function (event) {
    VueProgressBarEventBus.$Progress.start();
    let loader = document.getElementsByClassName("loader-overlay");
    loader[0].remove();
    VueProgressBarEventBus.$Progress.finish();
});

let authorizations = require('./authorizations');

Vue.prototype.authorize = function (...params) {

    if (!window.App.signedIn) return false;

    if (typeof params[0] === 'string') {
        return authorizations[params[0]](params[1]);
    }
    return params[0](window.App.user);
}

Vue.prototype.signedIn = window.App.signedIn;

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.token = token.content;

    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.events = new Vue();

import Toast from './mixins/SweetAlert';

window.Toast = Toast;
